interface ClipboardCheckIconStaticProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

export const ClipboardCheckIconStatic = ({
  width = 24,
  height = 24,
  className,
  color = "currentColor",
  strokeWidth = 2
}: ClipboardCheckIconStaticProps) => {
  return (
    <div className={className} style={{ width, height }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="8" height="4" x="8" y="2" rx="1" ry="1" stroke={color} strokeWidth={strokeWidth} />
        <path
          d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m9 14 2 2 4-4"
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
